var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "52 44 452 268",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Fio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52 34) scale(9.2)",
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
    fill: "#3D8B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 250            C 205 300 150 300 150 268            C 150 246 182 246 182 272            C 182 300 138 300 130 270            C 124 248 156 244 172 266            M 175 285            C 250 300 300 270 320 232",
    fill: "none",
    stroke: "#F5A623",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330 245            C 300 235 292 205 300 180            C 300 120 340 96 396 96            L 430 96            C 470 96 486 150 452 176            C 486 206 452 250 404 244            L 352 240            C 344 252 336 250 330 245 Z",
    fill: "none",
    stroke: "#F5A623",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 170,
    r: 12,
    fill: "#3D8B37"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 170,
    r: 12,
    fill: "#3D8B37"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 170,
    r: 12,
    fill: "#3D8B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFio);
export default __webpack_public_path__ + "static/media/logo-fio.557d441e8a7cac313c264fcc9cb76a03.svg";
export { ForwardRef as ReactComponent };